export default "/_next/static/assets/images/high-five-logo.4fb6678bf2acd8deef5385b5879ba851.png";